import React, {useEffect, useRef, useState} from "react";
import {router, usePage} from "@inertiajs/react";
import {useEnhancedTranslation} from "laravel-inertia-backend";
import InertiaTable from "laravel-inertia-react-table";
import {mdiFilterVariant, mdiPlus} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "react-bootstrap";
import MailView from "./Email/MailView.jsx";
import {ToggleButton, usePolling} from "laravel-inertia-backend";
import CommentInfoTableCell from "../Components/CommentInfoTableCell.jsx";
import PillTableCell from "../Components/PillTableCell.jsx";
import CurrencyTableCell from "../Components/CurrencyTableCell.jsx";
import OrderPreview from "./Orders/OrderPreview.jsx";

export default function Emails(props) {
    const {t} = useEnhancedTranslation();
    const {emails, extradata, filters, path} = usePage().props;
    const [mailViewId, setMailViewId] = React.useState(null);
    const filterNew = filters.filterNew === '1';
    const tableRef = useRef(null);
    const orderTableRef = useRef(null);
    const outerElementRef = useRef(null);
    const [tableElementWidth, setTableElementWidth] = useState(null);
    const [previewWidthRatio, setPreviewWidthRatio] = useState(0.5);
    const previewWidthRatioRef = useRef(previewWidthRatio);

    useEffect(() => {
        previewWidthRatioRef.current = previewWidthRatio;
    }, [previewWidthRatio]);

    const title = t(path === 'mail/mailorder' ? 'Mailorder' : 'Wholesale');
    const setFilterNew = (value) => {
        router.reload({data: {filter: {...filters, filterNew: value ? 1 : 0}}});
    }

    usePolling('emails');

    const handleAddClick = () => {
        router.get('mail/create');
    }

    const customToolbarButtons = (
        <ToggleButton className={"ms-2"} type="checkbox" id={"filter_new"} variant="outline-secondary"
                      checked={!!filterNew} onChange={(e) => setFilterNew(e.currentTarget.checked)}
                      value={"1"}>{t('only new')}</ToggleButton>);


    const handleRowClick = (mail) => {
        console.log(mail.id);
        setMailViewId(mail.id);
    }
    const handleMailViewContentRequest = (id) => {
        if (id) {
            setMailViewId(id);
            router.reload({only: ['extradata', 'emails'], data: {extradata: id}});
        } else {
            const url = new URL(window.location.href);
            // 'extradata'-Parameter entfernen
            url.searchParams.delete('extradata');
            // URL aktualisieren
            window.history.replaceState({}, document.title, url.toString());
        }
    }

    const onResizePreview = (width) => {
        //outerElementRef.current.style.width = width+"px";
        setPreviewWidthRatio(width / outerElementRef.current.getBoundingClientRect().width);
        setTableElementWidth(width);
    }

    useEffect(() => {
        // Funktion zur Berechnung der Breite
        const calculateWidth = () => {
            if (outerElementRef.current) {
                const width =
                    outerElementRef.current.getBoundingClientRect().width *
                    previewWidthRatioRef.current; // Greife auf "aktuelle" Version zu
                setTableElementWidth(width);
            }
        };

        calculateWidth(); // Initiale Brechnung der Breite

        // Event-Listener hinzufügen, um die Breite beim Fensterrandern zu aktualisieren
        window.addEventListener("resize", calculateWidth);

        return () => {
            window.removeEventListener("resize", calculateWidth); // Listener beim Unmount entfernen
        };
    }, []);


    const selectedIdRef = useRef(mailViewId);

    useEffect(() => {
        selectedIdRef.current = mailViewId;
    }, [mailViewId]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "ArrowUp") {
                event.preventDefault();
                const currentIndex = emails.data.findIndex(item => item.id === selectedIdRef.current);
                if (currentIndex > 0) {
                    const newSelectedId = emails.data[currentIndex - 1].id;
                    console.log("Navigating up, new ID:", newSelectedId);
                    setMailViewId(newSelectedId);
                }
            }
            if (event.key === "ArrowDown") {
                event.preventDefault();
                const currentIndex = emails.data.findIndex(item => item.id === selectedIdRef.current);
                if (currentIndex < emails.data.length - 1) {
                    const newSelectedId = emails.data[currentIndex + 1].id;
                    console.log("Navigating down, new ID:", newSelectedId);
                    setMailViewId(newSelectedId);
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [emails]);


    useEffect(() => {
        console.log("mailViewId changed");
        if (mailViewId && tableRef.current) {
            handleMailViewContentRequest(mailViewId);
            // Suche nach der Tabellenzeile, die zu der selectedId passt
            const row = tableRef.current.querySelector(`[data-id="${emails.data.findIndex(item => item.id === mailViewId)}"]`);
            console.log('Scrolling to row:');
            if (row) {

                row.scrollIntoView({
                    behavior: "smooth", // sorgt für sanftes Scrollen
                    block: "nearest" // Zeile wird zentriert
                });
            }
        }
    }, [mailViewId]);

    return (
        <>
            <div className="h-100 d-flex flex-row" ref={outerElementRef}>
                <div ref={orderTableRef} style={{width: mailViewId ? tableElementWidth + "px" : "100%"}}>
                    <InertiaTable
                        innerRef={tableRef} // Referenz für das Tabellen-Element
                        data={emails} title={title}
                        customRowStyle={(row) => {
                            if (row.status === 0) {
                                return {fontWeight: 'bolder'}
                            }
                        }}
                        options={{selectable: true}}
                        selectedIds={[mailViewId]}
                        customToolbarButtons={customToolbarButtons} onRowClick={handleRowClick}/>
                </div>
                <MailView show={mailViewId} mail={extradata} resizeRef={orderTableRef}
                          onClose={() => setMailViewId(null)} onResize={onResizePreview}/>
            </div>

        </>
    );
}



